

export default function DifferenceBubble(props) {

    const label = isNaN(props.percent) ? "N/A" : props.percent;
    const className = isNaN(props.percent) ? '' : props.percent < 0 ? "negative" : "positive";

    return(
        <div className="difference-bubble">
            <span className={className}>{label}</span>
        </div>
    )
}